import { RootState } from 'store/rootReducer';

export const IntroductionPageTeaserContentSelector = (state: RootState) => state.content.introductionPageTeaser;
